import './photo.css';

function Photo({ photo, width='160px', height='160px' }) {
    return (
        <div className="container-photo" style={{
            backgroundImage: `url(${photo})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            width,
            height
        }}>
        </div>
    );
}

export default Photo;